export class NameValue {

  constructor(
    public value?: string,
    public name?: string,
  ) {
  }
}
